import {ActionSource, ACTION_SOURCES} from '@domain/pom'
import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'
import {useTranslation} from 'react-i18next'

import {FILTER_VALUE_SEPARATOR, FEATURE_NAMESPACE} from '../../consts'

export const PomActionSourceFilter = <TName extends string>({
  ...props
}: Omit<FilterMultiSelectProps<ActionSource, TName>, 'options'>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options = Object.values(ACTION_SOURCES).map((actionSource) => ({
    value: actionSource,
    label: t(`pomAction.actionSource.${actionSource}`)
  }))

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      renderValue={(value) =>
        value
          .map((actionSource) => t(`pomAction.actionSource.${actionSource}`))
          .join(FILTER_VALUE_SEPARATOR)
      }
    />
  )
}
